module.exports = __webpack_public_path__ + "img/calculator.33242d7f.svg";